// ComparisonSection.jsx — side-by-side on desktop, stacked on mobile
import React from "react";

export default function ComparisonSection({ heading, left, right }) {
  if (!left || !right) return null;

  return (
    <div className="sx-container">
      <div className="sx-compare-wrapper">
        {heading && (
          <h3 className="sx-pipeline-heading">{heading}</h3>
        )}

        <div className="sx-compare-grid">
          {/* LEFT — "before" / traditional */}
          <div className="sx-compare-col sx-compare-col--left">
            <div className="sx-compare-col-head sx-compare-col-head--left">
              {left.title}
            </div>
            {Array.isArray(left.points) && left.points.map((point, i) => (
              <div key={i} className="sx-compare-row">
                <span className="sx-compare-icon sx-compare-icon--no">✕</span>
                <span className="sx-compare-text">{point}</span>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="sx-compare-divider" aria-hidden="true">
            <div className="sx-compare-vs">vs</div>
          </div>

          {/* RIGHT — SysMindX */}
          <div className="sx-compare-col sx-compare-col--right">
            <div className="sx-compare-col-head sx-compare-col-head--right">
              {right.title}
            </div>
            {Array.isArray(right.points) && right.points.map((point, i) => (
              <div key={i} className="sx-compare-row">
                <span className="sx-compare-icon sx-compare-icon--yes">✓</span>
                <span className="sx-compare-text">{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
